function ancestorsAndSelf(relativePath: string): string[] {
  const segments = relativePath.split('/').filter(Boolean);
  return segments.map((_, index) => segments.slice(0, index + 1).join('/'));
}

/**
 * Folders to create so a dropped folder's empty folders appear, shallowest
 * first so every parent exists before its child. Folders that already hold
 * an uploaded file exist and are left out.
 */
export function folderUploadDirectoriesToCreate(
  emptyDirectories: ReadonlyArray<string>,
  uploadedFileDirectories: ReadonlyArray<string | null>
): string[] {
  const existing = new Set(
    uploadedFileDirectories.flatMap((directory) =>
      directory ? ancestorsAndSelf(directory) : []
    )
  );
  const wanted = new Set(
    emptyDirectories.flatMap((directory) => ancestorsAndSelf(directory))
  );
  return [...wanted]
    .filter((directory) => !existing.has(directory))
    .sort(
      (a, b) => a.split('/').length - b.split('/').length || a.localeCompare(b)
    );
}

/** Splits `a/b/c` into the parent `a/b` and the name `c`. */
export function splitFolderUploadDirectory(relativePath: string): {
  parent: string | null;
  name: string;
} {
  const index = relativePath.lastIndexOf('/');
  return index < 0
    ? { parent: null, name: relativePath }
    : {
        parent: relativePath.slice(0, index),
        name: relativePath.slice(index + 1),
      };
}
